module.exports = __webpack_public_path__ + "img/icone_studio_10ans.5c19c342.png";